import TileLayer from "ol/layer/Tile";
import { Map } from "ol";
import OSM from "ol/source/OSM";
import BingMaps from 'ol/source/BingMaps.js';
import { boundingExtent, Extent } from 'ol/extent';
import TileWMS from "ol/source/TileWMS";
import { Observable, Subject } from "rxjs";
import { retry, takeUntil } from "rxjs/operators";
import { Site } from "src/app/bo/site";
import { HttpService } from "src/app/services/http.service";
import { LoggerService } from "src/app/services/logger.service";
import { HttpErrorResponse } from "@angular/common/http";
import { Coordinate } from "ol/coordinate";
import { transform, transformExtent } from "ol/proj";
import MapConstants from "../constants";
import { OrthophotoMapService } from "src/app/services/map.services";
import XYZ from "ol/source/XYZ";
import { Orthophoto, OrthoPhotoDto } from "src/app/bo/orthophoto";
import { url } from "inspector";


export enum MAP_VIEW_TYPE{ol, bing, geoserver};

const BING_MAP_EXTENT = 20000; //meters

function transformBounds(extent: Extent): Extent {
  return transformExtent(extent, 'EPSG:4326', 'EPSG:3857');
}

function transformCoord(coord: number[]): number[] {
  return transform(coord, 'EPSG:4326', 'EPSG:3857');
}


function transformLocal(extent) {
  return transformExtent(extent, 'EPSG:4326', 'EPSG:3857');
}
const extents = {
  India: transformLocal([68.17665, 7.96553, 97.40256, 35.49401]),
  Argentina: transformLocal([-73.41544, -55.25, -53.62835, -21.83231]),
  Nigeria: transformLocal([2.6917, 4.24059, 14.57718, 13.86592]),
  Sweden: transformLocal([11.02737, 55.36174, 23.90338, 69.10625]),
};



export class MapLayersControler{
    private readonly exploreHttpService: HttpService;
    private site: Site;
    private transformedSiteCoord: Coordinate;

    private readonly map: Map;
    private readonly authkey = "";
    private bingKey = "";
    private mapBoxMaps: TileLayer<XYZ>[] = [];
    private mapboxToken = ''; 
    private readonly logger: LoggerService;

    private readonly unsubscribe$ = new Subject<void>();

    stylesBingMap:string[] = [
        'Aerial',
        // 'RoadOnDemand',
        // 'AerialWithLabelsOnDemand',
        // 'CanvasDark',
        // 'OrdnanceSurvey',
      ];
    
    private osmLayer: TileLayer<OSM>;
    private readonly mapBoxLayer:TileLayer<any> = null;
    private bingMapLayer:TileLayer<any> = null;
    private orthophotoMaps: OrthoPhotoDto[] = [];
    

    public isOrthoLayerVisible = true;
    public isBingLayerVisible = false;
    public isOSMLayerVisible = true;


    constructor(map: Map,
        http: HttpService,
        site: Site,
        logger: LoggerService,
        private readonly zIndex:number,
        private readonly mapService: OrthophotoMapService){
            
        this.exploreHttpService = http;
        this.site = site;
        this.logger = logger;
        this.map = map;
        this.mapService.getMapBoxPublicKey().then(token => {
            this.mapboxToken = token;
            this.createMapboxSatellite(this.zIndex + 1);
        });

        //this.createOrthophotoLayer(zIndex+2);
        this.createMapboxSatellite(zIndex + 1);
        this.createOSMLayer();       

        this.osmLayer.setZIndex(zIndex);
        this.map.addLayer(this.osmLayer);

        const storedIsOrthoLayerVisible = localStorage.getItem('isOrthoLayerVisible');
        this.isOrthoLayerVisible = storedIsOrthoLayerVisible === null ? true : JSON.parse(storedIsOrthoLayerVisible);
        
        const storedIsBingLayerVisible = localStorage.getItem('isBingLayerVisible');
        this.isBingLayerVisible = storedIsBingLayerVisible === null ? false : JSON.parse(storedIsBingLayerVisible);
    }

    public destroy(){
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    public ChangeSite(site: Site) {

      this.site = site;
      this.transformedSiteCoord = this.transformCoordSite();
      if (null !== this.bingMapLayer && undefined !== this.bingMapLayer) {
        this.bingMapLayer.setExtent(this.getExtendBounds());
      }
      if(this.isBingLayerVisible){
        this.bingMapLayer.setVisible(true);
      }
      this.removeMapBoxMaps();
      this.mapService.getOrthophotoMaps(site.siteId).then((maps) => {
        this.orthophotoMaps = maps; // Store the orthophoto data
        this.setMapBoxMaps(maps).then(() => {
          if (this.isOrthoLayerVisible) {
            // Appliquer la visibilité seulement pour les orthophotos marquées comme visibles
            this.orthophotoMaps.forEach((orthoPhoto, index) => {
              if (orthoPhoto.isVisible && index < this.mapBoxMaps.length && this.mapBoxMaps[index]) {
                this.mapBoxMaps[index].setVisible(true);
              }
            });
          }
        });
      });
    }

    public toggleLayer(layer: MAP_VIEW_TYPE, visible: boolean){
        switch(layer){
            case MAP_VIEW_TYPE.ol:
                this.osmLayer.setVisible(visible);
                this.isOSMLayerVisible = visible;
                break;
            case MAP_VIEW_TYPE.bing:
                this.bingMapLayer.setVisible(visible);
                this.isBingLayerVisible = visible;
                localStorage.setItem('isBingLayerVisible', JSON.stringify(visible));

                break;
            case MAP_VIEW_TYPE.geoserver:
                //this.mapBoxLayer.setVisible(visible);
                this.mapBoxMaps.forEach((map) => {
                  map.setVisible(visible);
                });
                this.isOrthoLayerVisible = visible;
                localStorage.setItem('isOrthoLayerVisible', JSON.stringify(visible));
                break;
        }
    }

    public getOrthophotoMaps(): OrthoPhotoDto[] {
        return this.orthophotoMaps;
    }

    public updateOrthophotoOrder(newOrder: OrthoPhotoDto[]): void {
        this.orthophotoMaps = newOrder;
        this.removeMapBoxMaps();
        this.setMapBoxMaps(newOrder).then(() => {
            if (this.isOrthoLayerVisible) {
                // Appliquer la visibilité seulement pour les orthophotos marquées comme visibles
                this.orthophotoMaps.forEach((orthoPhoto, index) => {
                    if (orthoPhoto.isVisible && index < this.mapBoxMaps.length && this.mapBoxMaps[index]) {
                        this.mapBoxMaps[index].setVisible(true);
                    }
                });
            }
        });
    }
  public getMaxOrthophotoZIndex(): number {
        if (this.orthophotoMaps.length === 0) {
            return this.zIndex;
        }
        return this.zIndex + this.orthophotoMaps.length;
    }

    public getRecommendedBaseZIndexForOtherLayers(): number {
        return this.getMaxOrthophotoZIndex() + 10;
    }

    public toggleOrthophotoVisibility(orthophotoId: number, visible: boolean): void {
        const orthoPhoto = this.orthophotoMaps.find(map => map.id === orthophotoId);
        if (orthoPhoto) {
            orthoPhoto.isVisible = visible;
            const mapIndex = this.orthophotoMaps.indexOf(orthoPhoto);
            
            // Mettre à jour la visibilité si la couche existe
            if (mapIndex >= 0 && mapIndex < this.mapBoxMaps.length && this.mapBoxMaps[mapIndex]) {
                this.mapBoxMaps[mapIndex].setVisible(visible && this.isOrthoLayerVisible);
            }
        }
    }

    private createSingleOrthophotoLayer(orthoPhoto: OrthoPhotoDto, index: number): void {
        console.log(`Creating layer for orthophoto: ${orthoPhoto.mapName}, tiles: ${orthoPhoto.tiles}`);
        if (orthoPhoto.tiles !== null && orthoPhoto.tiles !== undefined && orthoPhoto.tiles.length > 0) {
            const mapExtent = transformBounds(orthoPhoto.bounds);
            let mapBoxLayer = new TileLayer<XYZ>({
                extent: mapExtent,
                source: new XYZ({
                    url: orthoPhoto.tiles
                }),
                visible: orthoPhoto.isVisible && this.isOrthoLayerVisible // Utiliser la visibilité souhaitée
            });

            // Invert zIndex: smallest zOrder gets highest zIndex
            const maxZOrder = Math.max(...this.orthophotoMaps.map(o => o.zOrder));
            mapBoxLayer.setZIndex(this.zIndex + 2 + (maxZOrder - orthoPhoto.zOrder));
            
            // S'assurer que le tableau a la bonne taille
            while (this.mapBoxMaps.length <= index) {
                this.mapBoxMaps.push(null);
            }
            
            this.mapBoxMaps[index] = mapBoxLayer;
            this.map.addLayer(mapBoxLayer);
            
            // Forcer immédiatement la visibilité et le rafraîchissement
            mapBoxLayer.setVisible(orthoPhoto.isVisible && this.isOrthoLayerVisible);
            this.map.render();
            
            console.log(`Created and added orthophoto layer for ${orthoPhoto.mapName} at index ${index}, visible: ${orthoPhoto.isVisible && this.isOrthoLayerVisible}`);
        } else {
            console.log(`Cannot create layer for ${orthoPhoto.mapName}: no tiles URL`);
        }
    }

      private createMapboxSatelliteLayer(zOrder: number): TileLayer<XYZ> {
        return new TileLayer({
          extent: this.getExtendBounds(),
          visible: false,
          preload: 1,
          source: new XYZ({
            url: `https://api.mapbox.com/styles/v1/mapbox/satellite-v9/tiles/256/{z}/{x}/{y}@2x?access_token=${this.mapboxToken}`,
            attributions: '© <a href="https://www.mapbox.com/about/maps/">Mapbox</a> © <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
            tileSize: 256,
            maxZoom: 20
          }),
        zIndex: zOrder
        });
      }
      private createMapboxSatellite(zOrder: number) {
        this.bingMapLayer = this.createMapboxSatelliteLayer(zOrder);
        this.map.addLayer(this.bingMapLayer);
      }
    private CreateBingLayer(Zorder: number){
        this.exploreHttpService.get<string>('Config/bingkey').subscribe({
            next:(key)=>{
                console.log("bing key: ", key);
                
                if(key !== null && key !== undefined && key !== ""){
                    this.bingKey = key;
                    console.log("create bing layer");
                    
                    this.createBingMapLayer().subscribe({
                        next:(bingLayer:TileLayer<any>)=>{
                            this.bingMapLayer = bingLayer;
                            this.bingMapLayer.setZIndex(Zorder);
                            this.map.addLayer(this.bingMapLayer);
                        },
                        error:(error:HttpErrorResponse)=>{
                            this.logger.logError("Error while creating bing layer: " + error.message);
                        }
                    });
                    
                    
                }
            },
            error:(error:HttpErrorResponse)=>{
                    this.logger.logError("Error while fetching bing key: " + error.message);
            }
        });
    }

    private createOSMLayer(){
        this.osmLayer= new TileLayer({
            source: new OSM()
        });
    }
  
    private removeMapBoxMaps(){
      this.mapBoxMaps.forEach((map) => {
        this.map.removeLayer(map);
      });
      this.mapBoxMaps = [];
    }

    private setMapBoxMaps(maps: OrthoPhotoDto[]): Promise<void> {
      return new Promise((resolve) => {
  maps.sort((a, b) => a.zOrder - b.zOrder);
  const maxZOrder = Math.max(...maps.map(o => o.zOrder));
  maps.forEach((map, index) => {
          console.log("map: ", map);
          if (map.tiles !== null && map.tiles !== undefined && map.tiles.length > 0) {
            const mapExtent = transformBounds(map.bounds);
            let mapBoxLayer = new TileLayer<XYZ>({
              extent: mapExtent,
              source: new XYZ({
                url: map.tiles
              }),
              visible: false // Toujours invisible au départ
            });
    
            // Invert zIndex: smallest zOrder gets highest zIndex
            mapBoxLayer.setZIndex(this.zIndex + 2 + (maxZOrder - map.zOrder));
            
            // S'assurer que le tableau a la bonne taille
            while (this.mapBoxMaps.length <= index) {
              this.mapBoxMaps.push(null);
            }
            
            this.mapBoxMaps[index] = mapBoxLayer;
            this.map.addLayer(mapBoxLayer);
          } else {
            // Même pour les orthophotos sans tiles, on réserve une place dans le tableau
            while (this.mapBoxMaps.length <= index) {
              this.mapBoxMaps.push(null);
            }
            this.mapBoxMaps[index] = null;
          }
        });
        resolve();
      });
    }
  
  // private createOrthophotoLayer(zOrder:number){
  //     this.mapBoxLayer =
  //       new TileLayer<XYZ>({
  //         source: null,
  //         visible: false
  //         });
          
  //       this.isOrthoLayerVisible = false;
  //     this.mapBoxLayer.setZIndex(zOrder);
  //     this.map.addLayer(this.mapBoxLayer);
  // }

  // private changeMapBoxTileSet(tileSetId: string):TileLayer<XYZ>{
  //   const rasterLayer = new TileLayer<XYZ>({
  //     //extent: mapExtent,
  //     source: new XYZ({
  //       url: ,
  //     }),
  //   });
  //   return rasterLayer;
  // }


  //Create a bingmap layer but returns it in an observable
  private createBingMapLayer(): Observable<TileLayer<any>> {

    return new Observable<TileLayer<any>>(observer => {
      try {
        console.log("createBingMapLayer: ", this.getExtendBounds());
        let source = new BingMaps({
          key: this.bingKey,
          imagerySet: this.stylesBingMap[0],
        });

        const bingMapLayer = new TileLayer({
          extent: this.getExtendBounds(),
          visible: false,
          preload: 1,
          source: source,
        });

        observer.next(bingMapLayer);
        observer.complete();
      } catch (error) {
        observer.error(error);
      }
    }).pipe(retry(3));
  }
  
    
  // private createBingMapLayer(): TileLayer<any>{
    
  //   try {
  //     return new TileLayer({
  //       extent: this.getExtendBounds(),
  //       visible: false,
  //       preload: 1,
  //       source: new BingMaps({
  //         key: this.bingKey,
  //         imagerySet: this.stylesBingMap[0],
  //       }),
  //     })
      
  //   } catch (error) {
  //     return null;
  //   }
  // }

  
  private getExtendBounds():number[]{
    if(null != this.transformedSiteCoord){
      return boundingExtent(this.getExtentFromCenterCoordinate(this.transformedSiteCoord, BING_MAP_EXTENT))
    }else{
      return null;
    }
  }

  private transformCoordSite():Coordinate{
    if(null != this.site.epsg && undefined != this.site.epsg && 
      null != this.site.coordX && undefined != this.site.coordX && 
      null != this.site.coordY && undefined != this.site.coordY
      ){
        const coordSite =  [this.site.coordX, this.site.coordY]
        let transformedCoord= transform(coordSite, 'EPSG:' + this.site.epsg, MapConstants.EPSG_REFERENCE_OL);
        console.log("transformedCoord: ", transformedCoord);
        
        return transformedCoord
      }else{
        return null;
      }
  }


  
  private getExtentFromCenterCoordinate(center: number[], dist: number):number[][]
  {
      // let distance = Math.sqrt(Math.pow((dist / 2), 2) + Math.pow((dist / 2), 2));
      // let rad_angle = (Math.PI / 180) * 45;
      // //left-top
      // let x1 = center[0] - distance * Math.cos(rad_angle);
      // let y1 = center[1] + distance * Math.sin(rad_angle);
      // //right-top
      // let x2 = center[0] + distance * Math.cos(rad_angle);
      // let y2 = center[1] + distance * Math.sin(rad_angle);
      // //right-bottom
      // let x3 = center[0] + distance * Math.cos(rad_angle);
      // let y3 = center[1] - distance * Math.sin(rad_angle);
      // //left-bottom
      // let x4 = center[0] - distance * Math.cos(rad_angle);
      // let y4 = center[1] - distance * Math.sin(rad_angle);

      let  extent_area: number[][] = []

      extent_area.push([center[0] - dist, center[1] + dist]);
      extent_area.push([center[0] + dist, center[1] + dist]);
      extent_area.push([center[0] + dist, center[1] - dist]);
      extent_area.push([center[0] - dist, center[1] - dist]);


      return extent_area;
  }


}
